/**
 * Browser-side namespace `Amri.*` — matches the legacy global the v2 Razor
 * partials still reference (e.g. `onclick="HandleDeferredClick(this, 'Amri.Home.GetCertifiedHandler')"`).
 *
 * Per-feature modules add themselves to `Amri.<Feature>` via the
 * `registerAmriModule()` helper below. The bundle entry (`amri-home.ts`)
 * imports each module so its registration side-effects run.
 *
 * Phase 3.8 scope: Amri (namespace), Amri.Home (carousel + accordion init).
 * Subsequent sub-phases extend with Amri.Login, Amri.Log, Amri.Social, etc.
 */

export type AmriNamespace = {
    /** Per-feature modules attach here (e.g. `Amri.Home`, `Amri.Login`). */
    [feature: string]: unknown;
};

/** Attach `Amri` to `window` on first import; idempotent on subsequent imports. */
function ensureAmri(): AmriNamespace {
    const w = window as unknown as { Amri?: AmriNamespace };
    w.Amri ??= {};
    return w.Amri;
}

export const Amri = ensureAmri();

/**
 * Register a feature module under `Amri.<key>`. Overwrites prior registrations
 * (last-import-wins), which only matters in tests; in normal use each module
 * is registered exactly once.
 */
export function registerAmriModule<T>(key: string, module: T): T {
    Amri[key] = module;
    return module;
}
